/* Emballage cadeau par produit — Numerigram, octobre 2026.

   Principe
   - La fiche (et l'ajout rapide) envoie la propriété cachée « _emballage » sur la ligne du
     produit, avec un message facultatif (snippets/sdo-emballage.liquid).
   - Ce script tient à jour, pour chaque ligne emballée, une ligne « Emballage cadeau »
     (produit emballage-cadeau, prix réglable dans l'admin) de même quantité, reliée par
     la propriété cachée « _lien » = clé de la ligne du produit, et visible « Pour : … ».
   - Dans le panier (tiroir et page), chaque ligne propose d'ajouter, de modifier ou de
     retirer l'emballage (snippets/sdo-emballage-ligne.liquid).
   - Toute modification du panier faite par le thème ou une app relance la synchronisation :
     lignes d'emballage orphelines retirées, quantités alignées, emballages manquants ajoutés. */
(function () {
  if (window.__sdoEmballage) return;
  window.__sdoEmballage = true;

  var EN = (document.documentElement.lang || '').toLowerCase().indexOf('en') === 0;
  var POUR = EN ? 'For' : 'Pour';
  var MSG = EN ? 'Gift message' : 'Message cadeau';
  var MSG_CLES = ['Message cadeau', 'Gift message'];
  var ROOT = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var MARQUE = { 'X-SDO-Emb': '1', 'Content-Type': 'application/json', Accept: 'application/json' };
  var CLE_SESSION = 'sdo-emb-actif';

  function memo(v) { try { if (v) sessionStorage.setItem(CLE_SESSION, '1'); return sessionStorage.getItem(CLE_SESSION) === '1'; } catch (e) { return true; } }

  /* ---------- Fiche produit : case et message ---------- */
  document.addEventListener('change', function (e) {
    var c = e.target.closest && e.target.closest('[data-sdo-emb-case]');
    if (!c) return;
    var bloc = c.closest('[data-sdo-emb]');
    var zone = bloc && bloc.querySelector('[data-sdo-emb-msg]');
    var champ = bloc && bloc.querySelector('[data-sdo-emb-texte]');
    if (zone) zone.hidden = !c.checked;
    if (champ) champ.disabled = !c.checked;
    if (c.checked) memo(true);
  });
  document.addEventListener('input', function (e) {
    var champ = e.target.closest && e.target.closest('[data-sdo-emb] [data-sdo-emb-texte]');
    if (!champ) return;
    var n = champ.closest('[data-sdo-emb]').querySelector('[data-sdo-emb-compte]');
    if (n) n.textContent = champ.value.length;
  });
  /* Juste avant l'envoi du formulaire produit : un message vide n'est pas envoyé
     (Shopify garderait une propriété vide), puis le champ redevient utilisable. */
  document.addEventListener('submit', function (e) {
    var champ = e.target.querySelector && e.target.querySelector('[data-sdo-emb] [data-sdo-emb-texte]');
    if (!champ) return;
    var c = e.target.querySelector('[data-sdo-emb-case]');
    var actif = !!(c && c.checked);
    champ.disabled = !actif || !champ.value.trim();
    setTimeout(function () { champ.disabled = !actif; }, 0);
  }, true);

  /* Le panier du thème écoute tout « change » remontant d'une ligne et l'envoie à /cart/change
     comme une quantité : on l'arrête pour nos champs. */
  ['change', 'input'].forEach(function (t) {
    document.addEventListener(t, function (e) {
      if (e.target.closest && e.target.closest('.sdo-emb-ligne')) {
        e.stopPropagation();
        if (t === 'input') {
          var f = e.target.closest('[data-sdo-emb-form]');
          var n = f && f.querySelector('[data-sdo-emb-compte]');
          if (n) n.textContent = e.target.value.length;
        }
      }
    }, true);
  });

  /* ---------- Accès au panier ---------- */
  var idEmballage = null;
  function varianteEmballage() {
    if (idEmballage) return Promise.resolve(idEmballage);
    return fetch(ROOT + 'products/emballage-cadeau.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (p) { idEmballage = p && p.variants && p.variants[0] ? p.variants[0].id : null; return idEmballage; })
      .catch(function () { return null; });
  }
  function lirePanier() { return fetch(ROOT + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function changer(cle, qte, props) {
    var corps = { id: cle, quantity: qte };
    if (props) corps.properties = props;
    return fetch(ROOT + 'cart/change.js', { method: 'POST', headers: MARQUE, body: JSON.stringify(corps) }).then(function (r) { return r.json(); });
  }
  function ajouter(items) {
    return fetch(ROOT + 'cart/add.js', { method: 'POST', headers: MARQUE, body: JSON.stringify({ items: items }) }).then(function (r) { return r.json(); });
  }
  /* Shopify ignore « properties: {} » dans change.js : pour vider les propriétés d'une
     ligne, on la retire puis on la rajoute sans propriétés. */
  function modifierLigne(cle, qte, props) {
    if (Object.keys(props || {}).length) return changer(cle, qte, props);
    var vid = parseInt(String(cle).split(':')[0], 10);
    return changer(cle, 0).then(function () { return ajouter([{ id: vid, quantity: qte }]); });
  }
  /* « item.properties | json » donne parfois une liste de paires : on la remet en objet. */
  function normaliser(p) {
    if (Array.isArray(p)) {
      var o = {};
      p.forEach(function (e) { if (Array.isArray(e) && e.length > 1) o[e[0]] = e[1]; });
      return o;
    }
    return p && typeof p === 'object' ? p : {};
  }
  function nomLigne(p) {
    var n = p.product_title || p.title || '';
    if (p.variant_title && !/default title/i.test(p.variant_title)) n += ' — ' + p.variant_title;
    return n;
  }

  /* ---------- Synchronisation ---------- */
  var enCours = null, aRefaire = false;
  function synchroniser() {
    if (enCours) { aRefaire = true; return enCours; }
    enCours = varianteEmballage().then(function (wid) {
      if (!wid) return false;
      return lirePanier().then(function (cart) {
        var parents = cart.items.filter(function (i) { return i.properties && i.properties._emballage; });
        var services = cart.items.filter(function (i) { return i.variant_id === wid; });
        if (!parents.length && !services.length) return false;
        memo(true);
        var etapes = [], vus = {};
        services.forEach(function (s) {
          var lien = s.properties && s.properties._lien;
          var p = parents.find(function (x) { return x.key === lien; });
          if (!p || vus[lien]) etapes.push(function () { return changer(s.key, 0); });
          else {
            vus[lien] = true;
            if (s.quantity !== p.quantity) etapes.push(function () { return changer(s.key, p.quantity); });
          }
        });
        var aAjouter = parents.filter(function (p) { return !vus[p.key]; }).map(function (p) {
          var props = { _lien: p.key };
          props[POUR] = nomLigne(p);
          return { id: wid, quantity: p.quantity, properties: props };
        });
        if (aAjouter.length) etapes.push(function () { return ajouter(aAjouter); });
        if (etapes.length) synchroEnCours(true);
        return etapes.reduce(function (pr, f) { return pr.then(f); }, Promise.resolve()).then(function () { return etapes.length > 0; });
      });
    }).catch(function () { return false; }).then(function (change) {
      enCours = null;
      if (change) rafraichir(); else synchroEnCours(false);
      if (aRefaire) { aRefaire = false; return synchroniser(); }
      return change;
    });
    return enCours;
  }

  /* ---------- Commandes dans les lignes du panier ----------
     Le bloc de chaque ligne vient de sections/sdo-emballage-panier.liquid (rendu par Shopify
     avec le panier courant) et se place juste avant la quantité. Le thème remplace tout le
     HTML des lignes à chaque mise à jour : on repasse alors sur les nouvelles lignes. */
  var injEnCours = false, injARefaire = false, cacheBlocs = {};
  /* Identité d'une ligne : clé + quantité (le bloc « × 2 emballages » dépend de la quantité). */
  function idLigne(r) {
    var q = r.querySelector('input.quantity__input, input[name="updates[]"]');
    return r.getAttribute('data-key') + '|' + (q ? q.value : '');
  }
  function lignesSansBloc() {
    return [].filter.call(document.querySelectorAll('.cart__item[data-key]'), function (r) {
      return r.getAttribute('data-sdo-emb-vu') !== idLigne(r);
    });
  }
  /* Pose le bloc d'une ligne (html déjà connu). Ne touche à rien si le bloc est identique. */
  function poser(row, html) {
    var cle = idLigne(row);
    var actuel = row.querySelector('.sdo-emb-ligne');
    if (actuel && actuel.getAttribute('data-sdo-emb-html') === html && row.getAttribute('data-sdo-emb-vu') === cle) return;
    if (actuel && actuel.contains(document.activeElement)) return;
    row.setAttribute('data-sdo-emb-vu', cle);
    [].forEach.call(row.querySelectorAll('.sdo-emb-ligne'), function (x) { x.remove(); });
    if (!html) return;
    var tpl = document.createElement('template');
    tpl.innerHTML = html;
    var bloc = tpl.content.firstElementChild;
    if (!bloc) return;
    bloc.setAttribute('data-sdo-emb-html', html);
    var q = row.querySelector('.cart__quantity');
    if (q && q.parentNode) q.parentNode.insertBefore(bloc, q);
    else row.appendChild(bloc);
  }
  /* La ligne « Emballage cadeau » s'affiche juste sous le produit qu'elle accompagne. */
  function ordonner() {
    [].forEach.call(document.querySelectorAll('.sdo-emb-ligne--service [data-lien]'), function (btn) {
      var srow = btn.closest('.cart__item[data-key]');
      var cle = btn.getAttribute('data-lien');
      if (!srow || !cle || !srow.parentNode) return;
      var prow = [].find.call(srow.parentNode.children, function (r) { return r.getAttribute && r.getAttribute('data-key') === cle; });
      srow.classList.toggle('sdo-emb-orphelin', !prow);
      if (prow && prow.nextElementSibling !== srow) prow.insertAdjacentElement('afterend', srow);
    });
    /* Le message global du tiroir fait doublon avec le message par produit. */
    [].forEach.call(document.querySelectorAll('cart-drawer button[onclick*="gift-note"]'), function (b) {
      if (b.style.display !== 'none') b.style.setProperty('display', 'none', 'important');
    });
  }
  /* Compteurs du panier (en-tête du tiroir, pastille de l'icône) : les emballages ne
     comptent pas comme des articles. */
  function nbEmballages() {
    var vus = {}, n = 0;
    [].forEach.call(document.querySelectorAll('.cart__item[data-key]'), function (r) {
      if (!r.querySelector('a[href*="/products/emballage-cadeau"]')) return;
      var k = r.getAttribute('data-key');
      if (vus[k]) return;
      vus[k] = true;
      var q = r.querySelector('input.quantity__input, input[name="updates[]"]');
      n += q ? (parseInt(q.value, 10) || 0) : 1;
    });
    return n;
  }
  function accorder(txt, n) {
    var t = txt.replace(/\d+/, n);
    if (n <= 1) t = t.replace(/articles/i, function (m) { return m.slice(0, -1); }).replace(/items/i, function (m) { return m.slice(0, -1); });
    else t = t.replace(/article(?!s)/i, function (m) { return m + 's'; }).replace(/item(?!s)/i, function (m) { return m + 's'; });
    return t;
  }
  /* « × 2 » à côté du prix de la ligne « Emballage cadeau » */
  function multiplicateurs() {
    [].forEach.call(document.querySelectorAll('.cart__item[data-key]'), function (r) {
      if (!r.querySelector('a[href*="/products/emballage-cadeau"]')) return;
      var prix = r.querySelector('.cart__final-price');
      if (!prix) return;
      var q = r.querySelector('input.quantity__input, input[name="updates[]"]');
      var n = q ? parseInt(q.value, 10) || 1 : 1;
      var x = prix.querySelector('.sdo-emb-x');
      var txt = n > 1 ? ' × ' + n : '';
      if (!txt) { if (x) x.remove(); return; }
      if (!x) { x = document.createElement('span'); x.className = 'sdo-emb-x'; prix.appendChild(x); }
      if (x.textContent !== txt) x.textContent = txt;
    });
  }
  /* 14/10/2026 : la page panier (#main-cart) suit le même compte que le tiroir (emballages exclus). */
  function compteurs() {
    multiplicateurs();
    var emb = nbEmballages();
    var els = document.querySelectorAll('cart-drawer .drawer__heading .js-contents, #main-cart .cart__heading .js-contents, #cart-icon-bubble .cart-count-bubble span, .cart__title-count, [data-sdo-compteur]');
    [].forEach.call(els, function (el) {
      var txt = el.textContent;
      if (el.getAttribute('data-sdo-aff') === txt) {
        /* déjà corrigé : on recalcule depuis la valeur d'origine si le nombre d'emballages a changé */
        if (el.getAttribute('data-sdo-emb') === String(emb)) return;
        txt = el.getAttribute('data-sdo-orig') || txt;
      } else {
        el.setAttribute('data-sdo-orig', txt);
      }
      var m = txt.match(/\d+/);
      if (!m) return;
      var n = Math.max(0, parseInt(m[0], 10) - emb);
      var aff = accorder(txt, n);
      el.setAttribute('data-sdo-emb', String(emb));
      el.setAttribute('data-sdo-aff', aff);
      if (el.textContent !== aff) el.textContent = aff;
    });
  }
  function synchroEnCours(oui) {
    [].forEach.call(document.querySelectorAll('cart-drawer-items, cart-items'), function (el) { el.classList.toggle('sdo-emb-synchro', oui); });
  }
  /* 1) tout de suite, depuis le cache (pas de saut d'affichage) ; 2) puis Shopify confirme. */
  function injecterCache() {
    var manque = false;
    lignesSansBloc().forEach(function (row) {
      var cle = idLigne(row);
      if (Object.prototype.hasOwnProperty.call(cacheBlocs, cle)) poser(row, cacheBlocs[cle]);
      else manque = true;
    });
    ordonner();
    return manque;
  }
  function injecter(forcer) {
    var manque = injecterCache();
    if (!manque && !forcer) return;
    if (injEnCours) { injARefaire = true; return; }
    injEnCours = true;
    fetch(ROOT + 'cart?section_id=sdo-emballage-panier', { credentials: 'same-origin' })
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var doc = new DOMParser().parseFromString(html, 'text/html');
        cacheBlocs = {};
        var parCle = {};
        [].forEach.call(doc.querySelectorAll('template[data-sdo-emb-pour]'), function (x) {
          var h = x.innerHTML.trim();
          cacheBlocs[x.getAttribute('data-sdo-emb-pour') + '|' + x.getAttribute('data-sdo-emb-qte')] = h;
          parCle[x.getAttribute('data-sdo-emb-pour')] = h;
        });
        [].forEach.call(document.querySelectorAll('.cart__item[data-key]'), function (row) {
          var cle = idLigne(row);
          poser(row, Object.prototype.hasOwnProperty.call(cacheBlocs, cle) ? cacheBlocs[cle] : (parCle[row.getAttribute('data-key')] || ''));
        });
        ordonner();
      })
      .catch(function () {})
      .then(function () {
        injEnCours = false;
        if (injARefaire) { injARefaire = false; injecter(true); }
      });
  }
  /* 14/10/2026 : une seule passe par image affichée, quel que soit le nombre de changements
     dans la page (avant : une passe à chaque changement, coûteux au chargement sur mobile). */
  var minInj = null, passe = 0;
  function repasser() {
    passe = 0;
    if (lignesSansBloc().length) injecterCache(); else ordonner();
    compteurs();
    clearTimeout(minInj);
    minInj = setTimeout(function () { if (lignesSansBloc().length) injecter(true); }, 150);
  }
  new MutationObserver(function () {
    if (!passe) passe = requestAnimationFrame(repasser);
  }).observe(document.documentElement, { childList: true, subtree: true });

  /* ---------- Rafraîchissement de l'affichage ---------- */
  function rendre() {
    var garde = setTimeout(function () { synchroEnCours(false); }, 4000);
    return lirePanier().then(function (cart) {
      if (cart.item_count === 0) return rendreVide();
      return rendreLignes();
    }).catch(rendreLignes).then(function () { clearTimeout(garde); synchroEnCours(false); });
  }
  function rendreLignes() {
    var att = [];
    var page = document.querySelector('cart-items');
    if (page && typeof page.onCartUpdate === 'function') att.push(page.onCartUpdate());
    var tiroir = document.querySelector('cart-drawer-items');
    if (tiroir && typeof tiroir.onCartUpdate === 'function') att.push(tiroir.onCartUpdate());
    return Promise.all(att.map(function (x) { return Promise.resolve(x).catch(function () {}); }));
  }
  /* Panier devenu vide après le retrait automatique d'un emballage : le thème ne re-rend que
     les lignes, sans l'état « panier vide ». On recharge tout le tiroir (et la page panier). */
  function rendreVide() {
    if (/\/cart\/?$/.test(location.pathname)) { location.reload(); return; }
    var cd = document.querySelector('cart-drawer');
    if (!cd || typeof cd.getSectionsToRender !== 'function' || typeof cd.renderContents !== 'function') return rendreLignes();
    var ids = cd.getSectionsToRender().map(function (x) { return x.id; });
    var ouvert = cd.classList.contains('active');
    return fetch(ROOT + '?sections=' + ids.join(','), { credentials: 'same-origin' })
      .then(function (r) { return r.json(); })
      .then(function (sections) {
        if (!ouvert) cd.open = function () {};
        cd.renderContents({ sections: sections });
        setTimeout(function () {
          if (!ouvert) delete cd.open;
          cd.classList.add('is-empty');
          var inner = cd.querySelector('.drawer__inner');
          if (inner) inner.classList.add('is-empty');
        }, 0);
      })
      .catch(rendreLignes);
  }
  function rafraichir() {
    /* Dans l'ajout rapide, le thème re-rend le tiroir après la fermeture de la fenêtre :
       on passe après lui. */
    if (document.querySelector('quick-add-modal[open]')) {
      document.body.addEventListener('modalClosed', function () { setTimeout(rafraichir, 700); }, { once: true });
      return;
    }
    rendre();
  }

  /* ---------- Détection des changements faits par le thème ou une app ---------- */
  var origFetch = window.fetch;
  var minuteur = null;
  function planifier() { clearTimeout(minuteur); minuteur = setTimeout(synchroniser, 250); }
  window.fetch = function (ressource, options) {
    var url = typeof ressource === 'string' ? ressource : (ressource && ressource.url) || '';
    var nous = false;
    try {
      var h = (options && options.headers) || {};
      nous = !!(h['X-SDO-Emb'] || (h.get && h.get('X-SDO-Emb')));
    } catch (e) {}
    var p = origFetch.apply(this, arguments);
    if (!nous && /\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
      p.then(function () { if (memo() || /\/cart\/add/.test(url)) planifier(); }).catch(function () {});
    }
    return p;
  };

  /* ---------- Commandes sur les lignes du panier ---------- */
  function lignePropsSans(props) {
    var o = {};
    Object.keys(props || {}).forEach(function (k) {
      if (k === '_emballage' || MSG_CLES.indexOf(k) > -1) return;
      o[k] = props[k];
    });
    return o;
  }
  function occupe(el, oui) { if (el) { el.classList.toggle('est-occupe', oui); el.setAttribute('aria-busy', oui ? 'true' : 'false'); } }

  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-sdo-emb-action]');
    if (!b) return;
    e.preventDefault();
    var action = b.getAttribute('data-sdo-emb-action');
    var ligne = b.closest('[data-sdo-emb-ligne]');
    var form = ligne && ligne.querySelector('[data-sdo-emb-form]');

    if (action === 'ajouter' || action === 'message') {
      if (form) { form.hidden = false; var t = form.querySelector('textarea'); if (t) t.focus(); }
      b.hidden = action === 'ajouter';
      return;
    }
    if (action === 'annuler') {
      if (form) form.hidden = true;
      var aj = ligne && ligne.querySelector('[data-sdo-emb-action="ajouter"]');
      if (aj) aj.hidden = false;
      return;
    }
    if (action === 'valider' || action === 'retirer') {
      if (!ligne) return;
      var props = {};
      try { props = normaliser(JSON.parse(ligne.getAttribute('data-props') || '{}')); } catch (x) {}
      var nouv = lignePropsSans(props);
      if (action === 'valider') {
        nouv._emballage = '1';
        var txt = form && form.querySelector('textarea') ? form.querySelector('textarea').value.trim().slice(0, 150) : '';
        if (txt) nouv[MSG] = txt;
        memo(true);
      }
      occupe(ligne, true);
      var cleL = ligne.getAttribute('data-key');
      lirePanier().then(function (cart) {
        var it = cart.items.find(function (i) { return i.key === cleL; });
        if (!it) return;
        return modifierLigne(cleL, it.quantity, nouv);
      })
        .then(function () { return synchroniser(); })
        .then(function (change) { if (!change) rafraichir(); })
        .catch(function () { occupe(ligne, false); });
      return;
    }
    if (action === 'retirer-service') {
      var lien = b.getAttribute('data-lien');
      occupe(b.closest('.cart__item') || b, true);
      lirePanier().then(function (cart) {
        var p = cart.items.find(function (i) { return i.key === lien; });
        if (p) return modifierLigne(p.key, p.quantity, lignePropsSans(p.properties));
        var s = cart.items.find(function (i) { return i.properties && i.properties._lien === lien; });
        if (s) return changer(s.key, 0);
      }).then(function () { return synchroniser(); }).then(function (change) { if (!change) rafraichir(); });
    }
  });

  /* ---------- Au chargement : nettoyage si des emballages ont été utilisés ---------- */
  function auDemarrage() { injecter(); if (memo() || /\/cart\/?$/.test(location.pathname)) synchroniser(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', auDemarrage); else auDemarrage();
})();
